export const CUSTOM_ICON_BUTTON_VARIANT = {
  default: 'default',
  silver: 'silver',
  outlined: 'outlined',
  primary: 'primary',
};

export const CUSTOM_ICON_BUTTON_SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const getFontSize = (size) => {
  switch (size) {
    case CUSTOM_ICON_BUTTON_SIZE.large:
      return 24;

    case CUSTOM_ICON_BUTTON_SIZE.small:
    case CUSTOM_ICON_BUTTON_SIZE.medium:
    default:
      return 16;
  }
};
